import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Input,
  signal,
} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Configuration } from '@ubie/core';
import { MenuItem } from '../../../interfaces/menu-item.interface';

@Component({
  selector: 'acl-configuration-popover',
  standalone: false,
  templateUrl: './configuration-popover.component.html',
  styleUrl: './configuration-popover.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurationPopoverComponent {
  private readonly popoverController = inject(PopoverController);

  readonly _configuration = signal<Configuration | undefined>(undefined);
  // add menu according to configuration from configuration list

  @Input() set menus(menus: MenuItem[]) {
    this._menus.set(menus);
  }

  @Input() set configuration(configuration: Configuration | undefined) {
    this._configuration.set(configuration);
  }

  readonly _menus = signal<MenuItem[]>([]);

  readonly canInstall = computed(
    () =>
      !this._configuration()?.pending &&
      this._configuration()?.accepted &&
      !this._configuration()?.installed,
  );

  // send selected mnu name to configuration list
  clickMenu(menu: string): void {
    this.popoverController.dismiss(menu.toLowerCase());
  }
}
